import { Injectable, Output, EventEmitter } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { UtilisateurAngular } from '../models/UtilisateurAngular';
import { AccountApiService } from '../web-api-services/account.service';

@Injectable({
  providedIn: 'root',
})
export class AccountService {
  constructor(private accountApiService: AccountApiService) {}

  @Output() isLogged: EventEmitter<boolean> = new EventEmitter();

  getUtilisateurInfo(reload: boolean = false): Observable<UtilisateurAngular> {
    let utilisateurAngular = this.getUtilisateurAngular();
    if (utilisateurAngular == null || reload) {
      return this.accountApiService.getUtilisateurInfo().pipe(
        map(u => {
          sessionStorage.setItem('UtilisateurAngular', JSON.stringify(u));
          return u;
        }),
      );
    } else {
      return of(utilisateurAngular);
    }
  }

  getUtilisateurAngular(): UtilisateurAngular {
    return <UtilisateurAngular>JSON.parse(sessionStorage.getItem('UtilisateurAngular'));
  }

  login(psqs: string, cryptedId: string, id: string, check: string): Observable<UtilisateurAngular> {
    return this.accountApiService.login({ Psqs: psqs, cryptedId: cryptedId ? parseInt(cryptedId) : null, id: id ? parseInt(id) : null, check: check }).pipe(
      map(u => {
        if (u && u.Token) {
          sessionStorage.setItem('UtilisateurAngular', JSON.stringify(u));
          this.isLogged.emit(true);
        }
        return u;
      }),
    );
  }

  logout() {
    // remove user from local storage to log user out
    sessionStorage.removeItem('UtilisateurAngular');
    this.isLogged.emit(false);
  }

  getToken(): string {
    return this.getUtilisateurAngular()?.Token || '';
  }

  resetLasts() {
    this.lastSiteId = null;
    this.lastEtablissementId = null;
    this.lastAnnee = null;
    this.lastAnneeRealise = null;
  }

  private _lastEtablissementId: number;
  set lastEtablissementId(value: number) {
    this._lastEtablissementId = value;
    sessionStorage.setItem('lastEtablissementId', value ? value.toString() : null);
  }
  get lastEtablissementId(): number {
    if (!this._lastEtablissementId) {
      this._lastEtablissementId = <number>JSON.parse(sessionStorage.getItem('lastEtablissementId'));
    }
    return this._lastEtablissementId;
  }

  private _lastSiteId: number;
  set lastSiteId(value: number) {
    this._lastSiteId = value;
    sessionStorage.setItem('lastSiteId', value ? value.toString() : null);
  }
  get lastSiteId(): number {
    if (!this._lastSiteId) {
      this._lastSiteId = <number>JSON.parse(sessionStorage.getItem('lastSiteId'));
    }
    return this._lastSiteId;
  }

  private _lastAnnee: number;
  set lastAnnee(value: number) {
    this._lastAnnee = value;
    sessionStorage.setItem('lastAnnee', value ? value.toString() : null);
  }
  get lastAnnee(): number {
    if (!this._lastAnnee) {
      this._lastAnnee = <number>JSON.parse(sessionStorage.getItem('lastAnnee'));
    }
    return this._lastAnnee;
  }

  private _lastAnneeRealise: number;
  set lastAnneeRealise(value: number) {
    this._lastAnneeRealise = value;
    sessionStorage.setItem('lastAnneeRealise', value ? value.toString() : null);
  }
  get lastAnneeRealise(): number {
    if (!this._lastAnneeRealise) {
      this._lastAnneeRealise = <number>JSON.parse(sessionStorage.getItem('lastAnneeRealise'));
    }
    return this._lastAnneeRealise;
  }
}
